(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["@makolab/library-react/dist/OneDaciaHeaderDesktopMenuDirectLink"] = factory();
	else
		root["@makolab/library-react/dist/OneDaciaHeaderDesktopMenuDirectLink"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/project_fcn_library-react/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 263);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/Link");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/styles");

/***/ }),

/***/ 263:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DirectLink", function() { return DirectLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_flow__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_flow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_flow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Link__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__icon_icon__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__icon_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__icon_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__direct_menu_link_jss__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__direct_menu_link_types__ = __webpack_require__(265);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DirectLink=function(_Component){_inherits(DirectLink,_Component);function DirectLink(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DirectLink);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DirectLink.__proto__||Object.getPrototypeOf(DirectLink)).call.apply(_ref,[this].concat(args))),_this),_this.handleClick=function(){var _this$props=_this.props,onClick=_this$props.onClick,id=_this$props.id;onClick(id);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DirectLink,[{key:'render',value:function render(){var _props=this.props,classes=_props.classes,link=_props.link,iconId=_props.iconId,opened=_props.opened;var entryType=link.entryType,newTab=link.newTab,url=link.url,text=link.text;var component=entryType==='directLink'?'a':'button';var target=newTab?'_blank':'_self';var onClick=entryType==='directLink'?undefined:this.handleClick;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Link___default.a,{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes.root,opened&&classes.opened),component:component,href:url,target:target,underline:'none',variant:'body1',onClick:onClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,text),iconId&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__icon_icon___default.a,{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes.icon,_defineProperty({},classes.reverseIcon,opened)),id:iconId,size:13}));}}]);return DirectLink;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);DirectLink.displayName='DirectLink';DirectLink.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),link:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_8__direct_menu_link_types__["a" /* DIRECT_LINK_PROP_TYPE */]).isRequired,opened:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,iconId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,onClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};DirectLink.defaultProps={iconId:'',opened:false,onClick:function onClick(){}};/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_3_lodash_flow___default()([Object(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__["withStyles"])(__WEBPACK_IMPORTED_MODULE_7__direct_menu_link_jss__["a" /* default */])])(DirectLink));

/***/ }),

/***/ 264:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* harmony default export */ __webpack_exports__["a"] = (function(theme){var _root;return{root:(_root={position:'relative',padding:theme.spacing.unit*2,width:'100%',color:'#000000',fontFamily:['daciaSpirit','sans-serif'].join(', '),fontSize:'16px',fontWeight:700,textAlign:'left',textTransform:'uppercase'},_defineProperty(_root,theme.breakpoints.up('sm'),{fontSize:'0.838rem',color:'#000000'}),_defineProperty(_root,theme.breakpoints.up('md'),{fontSize:'12px',padding:'3px',height:'100%',display:'flex',alignItems:'center',maxWidth:'200px'}),_defineProperty(_root,theme.breakpoints.up('lg'),{fontSize:'0.838rem',padding:'0 '+theme.spacing.unit+'px',marginTop:'4px'}),_defineProperty(_root,'&:hover, &:focus',_defineProperty({},theme.breakpoints.up('md'),{color:'#000000',fontWeight:700})),_defineProperty(_root,'& span',_defineProperty({},theme.breakpoints.up('md'),{textAlign:'center'})),_root),icon:_defineProperty({position:'absolute',top:'50%',transform:'translateY(-50%)',right:theme.spacing.unit,width:13},theme.breakpoints.up('md'),{display:'none'}),opened:_defineProperty({backgroundColor:'#f2f2f2',paddingLeft:36,lineHeight:1.15},theme.breakpoints.up('md'),{backgroundColor:'transparent',color:'unset',paddingLeft:theme.spacing.unit}),reverseIcon:{left:8,transform:'translateY(-50%) rotate(-180deg)'}};});

/***/ }),

/***/ 265:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DIRECT_LINK_PROP_TYPE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
var DIRECT_LINK_PROP_TYPE={'@id':__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,newTab:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,entryType:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['megaDropDown','dropDownList','directLink']),url:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,text:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,megaDropDown:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,dropdown:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object};

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("lodash/flow");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("classnames");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@makolab/library-react/dist/Icon");

/***/ })

/******/ });
});
//# sourceMappingURL=OneDaciaHeaderDesktopMenuDirectLink.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@makolab/library-react/dist/OneDaciaHeaderDesktopMenuDirectLink.js
// module id = 585
// module chunks = 0